import useGetToken from './useGetToken';
import authFetch from '../../helpers/requests';
import {DeletingOptions} from '../grid-dx/types';

function useDelete(url: string) {
  const token = useGetToken();
  return async (deletingOptions: DeletingOptions) => {
    var values = {...deletingOptions.additional, ...deletingOptions.row};
    try {
      const response = await authFetch(
        `${url}`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
          },
          body: JSON.stringify(JSON.stringify(values)),
        },
        token,
      );
      return response;
    } catch (e) {
      return e;
    }
  };
}

export default useDelete;
